import React from 'react';
import { isNative, isIOS, isAndroid, getPlatformClass } from '../../utils/platformUtils';
import './InventoryLayout.css';

const InventoryLayout = ({
  children,
  className = '',
  style = {},
  ...props
}) => {
  const layoutStyle = { ...style };
  
  // On native, ensure the layout takes up the full screen height
  if (isNative()) {
    if (isAndroid()) {
      layoutStyle.minHeight = '100vh';
    } else if (isIOS()) {
      // Do NOT set minHeight: 100vh on iOS, as it causes nav bar issues
      layoutStyle.minHeight = 0;
    }
  }

    return (
    <div
      className={`inventory-layout ${getPlatformClass()} ${className}`}
      style={layoutStyle}
      {...props}
    >
      {/* Main Content */}
      <div className="inventory-content">
        {children}
      </div>
    </div>
  );
};

export default InventoryLayout; 